/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Image_Export_Style_Preset_Delete_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to delete preset. {error}" |
*
* @param {Image_Export_Style_Preset_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_delete_failed = /** @type {((inputs: Image_Export_Style_Preset_Delete_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_Delete_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la suppression du prereglage. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellung konnte nicht gelöscht werden. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare il preset. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить предустановку. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar el ajuste preestablecido. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除预设失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセットの削除に失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट को हटाने में विफल। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao excluir a predefinição. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to delete preset. ${i?.error}`)
});